module.exports = __webpack_public_path__ + "static/media/splash.790fbf3d.jpg";